const translations = {
    applications: 'Applications',
    editClient: 'Edit Client',
    linkedEntities: 'Linked Entities'
};

export default translations;
